import script from "./ResourceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceView.vue?vue&type=script&setup=true&lang=js"

import "./ResourceView.vue?vue&type=style&index=0&id=6d2a56e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2a56e9"]])

export default __exports__